import { useEffect, useState } from "react";
import { Scale } from "lucide-react";
import { scrollToForm } from "./Shared";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed z-50 top-0 left-0 right-0 h-20 flex items-center justify-between px-5 sm:px-10 lg:px-16 border-b transition-colors duration-500 ${
        scrolled
          ? "bg-[#FBF9F5]/92 backdrop-blur-md border-[#E7E2DA]"
          : "bg-[#FBF9F5] border-transparent"
      }`}
    >
      <a
        href="/"
        data-testid="brand-home-link"
        className="flex items-center gap-3 group"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <span className="flex h-10 w-10 items-center justify-center border border-[#1A1715] rounded-sm transition-colors duration-300 group-hover:bg-[#1A1715] group-hover:text-[#FBF9F5]">
          <Scale className="h-5 w-5" strokeWidth={1.75} />
        </span>
        <span className="leading-tight">
          <span className="block font-serif font-semibold text-lg text-[#1A1715] tracking-tight">
            Lawsuit Settlement Help
          </span>
          <span className="block font-mono text-[10px] uppercase tracking-[0.24em] text-[#78716C]">
            Consumer Intake · Nationwide
          </span>
        </span>
      </a>

      <button
        type="button"
        data-testid="nav-cta-button"
        onClick={scrollToForm}
        className="hidden sm:inline-flex items-center bg-[#1A1715] text-[#FBF9F5] font-sans font-semibold text-sm px-6 py-3 rounded-sm transition-colors duration-300 hover:bg-[#C2410C] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#1A1715]"
      >
        Free Case Review
      </button>
    </header>
  );
};

export default Navbar;
